module.exports = __webpack_public_path__ + "static/media/Screenshot_2026-02-06_at_14.13.52-removebg-preview.5a41c01d.png";